export default "__VITE_ASSET__Cl9O6$Zj__"